import React from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

function History({ t, versions, lang }) {
  return (
    <div className="container">
      <div className="card">
        <div className="card-header">{t('title')}</div>
        {versions.map((version, index) => (
          <HistoryVersion key={index} version={version} lang={lang} />
        ))}
      </div>
    </div>
  );
}

function HistoryVersion({ version, lang }) {
  let features;
  if (lang === 'fr') {
    features = version.featuresFr;
  } else {
    features = version.featuresEn;
  }

  return (
    <div className="card-body" style={{textAlign:'justify'}}>
      <h5 className="card-title">{version.version}</h5>
      <ul>
        {features.map((feature, index) => (
          <Feature key={index} feature={feature} />
        ))}
      </ul>
    </div>
  );
}

function Feature({ feature }) {
  return <li>{feature}</li>;
}

History.propTypes = {
  t: PropTypes.func.isRequired,
  versions: PropTypes.array.isRequired,
  lang: PropTypes.string.isRequired,
};

HistoryVersion.propTypes = {
  lang: PropTypes.string.isRequired,
  version: PropTypes.object,
  feature: PropTypes.string,
};

Feature.propTypes = {
  feature: PropTypes.string,
};
export default translate('History')(History);



// WEBPACK FOOTER //
// ./src/components/History/index.js